var _rect, _rect2, _circle, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentCancellation(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 404,
    viewBox: "0 0 688 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 140.5,
    width: 687,
    height: 263,
    rx: 31.5,
    stroke: "#EB5757"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 100,
    width: 608,
    height: 264,
    rx: 32,
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 344,
    cy: 100,
    r: 100,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310.603 66.6032C312.295 64.9109 315.039 64.9109 316.731 66.6032L344.001 93.8724L371.27 66.6032C372.962 64.9109 375.706 64.9109 377.398 66.6032C379.09 68.2955 379.09 71.0392 377.398 72.7314L350.129 100.001L377.398 127.27C379.09 128.962 379.09 131.706 377.398 133.398C375.706 135.09 372.962 135.09 371.27 133.398L344.001 106.129L316.731 133.398C315.039 135.09 312.295 135.09 310.603 133.398C308.911 131.706 308.911 128.962 310.603 127.27L337.872 100.001L310.603 72.7314C308.911 71.0392 308.911 68.2955 310.603 66.6032Z",
    fill: "#F6F4F2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentCancellation);
export default __webpack_public_path__ + "static/media/payment-cancellation.3ee347396e5f32d0e5734bed487d0949.svg";
export { ForwardRef as ReactComponent };